import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const OverlineMd = styled.span(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { overlineMd }, }, }, }, }) => css `
      ${renderTextVariations(overlineMd, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { OverlineMd as default };
